import gql from 'graphql-tag'

export const listContentTranslationLanguages = gql`
query listContentTranslationLanguages {
	cashAssist {
		listContentTranslationLanguages {
			items {
				id
				locale
				order
			}
		}
	}
}
`
export const createLanguageMutation = gql`
mutation createContentTranslationLanguage($locale: Locale!) {
	cashAssist {
		createContentTranslationLanguage(required: {
			locale: $locale
		}) {
			id
			locale
			order
		}
	}
}
`
export const updateLanguageOrderMutation = gql`
mutation updateContentTranslationLanguageOrder($records: [ContentTranslationLanguageOrder!]!) {
	cashAssist {
		updateContentTranslationLanguageOrder(records: $records) {
			id
			locale
			order
		}
	}
}
`
export const deleteLanguageMutation = gql `
mutation deleteContentTranslationLanguage($id: ID!) {
	cashAssist {
		deleteContentTranslationLanguage(id: $id) {
			id
			locale
			order
		}
	}
}
`
